import { grey } from "@mui/material/colors";

const styles = {
  leftContainer: (inDialogFlow: boolean) => ({
    p: { xs: 2, md: 4 },
    marginTop: { xs: 0, md: inDialogFlow ? 0 : 2 },
    marginLeft: { xs: 0, md: inDialogFlow ? 0 : 4 },
    borderRadius: { xs: 0, md: inDialogFlow ? 0 : 4 },
    justifyContent: "flex-end",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  }),
  rightContainer: {
    backgroundColor: "white",
    px: { xs: 1, md: 2, lg: 3 },
    py: { xs: 2, md: 4, lg: 6 },
    pt: { xs: 2, md: 12, lg: 14 },
    alignItems: "flex-start",
  },
  tabContainer: {
    display: "inline-flex",
    backgroundColor: "#F3F4F6",
    borderRadius: "10px",
    p: "4px",
    gap: "2px",
  },
  tab: {
    cursor: "pointer",
    textDecoration: "none",
    color: grey[600],
    textTransform: "none",
    fontSize: 13,
    fontWeight: 500,
    borderRadius: "7px",
    py: "8px",
    px: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    lineHeight: 1,
    transition: "all 0.18s ease",
    userSelect: "none",
    "&:hover": {
      color: grey[900],
      backgroundColor: "rgba(0,0,0,0.04)",
    },
  },
  active: {
    color: "#101828",
    fontWeight: 600,
    backgroundColor: "white",
    boxShadow: "0 1px 3px rgba(0,0,0,0.10), 0 1px 2px rgba(0,0,0,0.06)",
    "&:hover": {
      backgroundColor: "white",
    },
  },
  annotation: {
    display: "inline-flex",
    alignItems: "center",
    fontSize: 10,
    color: "#2B7FFF",
    lineHeight: 1.4,
  },
  coupon: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.02em",
    textTransform: "uppercase",
    backgroundColor: "#F0FDF4",
    color: "#15803D",
    border: "1px solid #BBF7D0",
    borderRadius: "6px",
    px: 1,
    py: 0.25,
    gap: 0.5,
    "&:hover": {
      backgroundColor: "#DCFCE7",
      borderColor: "#86EFAC",
    },
  },
  deleteAddOnButton: (isLoading: boolean) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 18,
    height: 18,
    ml: 0.75,
    borderRadius: "50%",
    cursor: isLoading ? "wait" : "pointer",
    color: grey[400],
    border: `1px solid ${grey[300]}`,
    transition: "color 0.15s, border-color 0.15s, background-color 0.15s",
    verticalAlign: "middle",
    "&:hover": {
      color: "#DC2626",
      borderColor: "#FCA5A5",
      backgroundColor: "#FEF2F2",
    },
  }),
};

export default styles;
